import { render, staticRenderFns } from "./ContentTypeImage.vue?vue&type=template&id=869d01e0&scoped=true&"
import script from "./ContentTypeImage.vue?vue&type=script&lang=js&"
export * from "./ContentTypeImage.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeImage.vue?vue&type=style&index=0&id=869d01e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869d01e0",
  null
  
)

export default component.exports